<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark"> Novo Link </span>
      </h3>
    </div>
    <Form url="/link/create" :link="link" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import LinkData from "./LinkData";
import { mapGetters } from "vuex";

export default {
  name: "app-link-create",
  data() {
    return {
      link: new LinkData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
